module.exports = __webpack_public_path__ + "media/images/badge/esperto-b18a1b4ade3a813cb748788d54757893.png";